<p-dialog class="createNewAssetDialog" [(visible)]="isVisible" [draggable]="false" [style]="{width: '65vw'}"
  (onHide)="onHideEmitter()">
  <ng-template pTemplate="header">
    <h3>Add New Asset Record</h3>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="p-grid p-mx-5">
      <div class="p-col-12 p-mb-3 align-right">
        <p-selectButton [options]="creationModeOptions" [(ngModel)]="selectedCreationMode" optionLabel="label"
          optionValue="value" (onChange)="onCreationModeChange($event)"
          pTooltip="Choose between single and multiple asset creation" tooltipPosition="top"
          [style]="{'width': 'auto'}">
        </p-selectButton>
      </div>

      <div *ngIf="selectedCreationMode === 'multiple'" class="p-col-12">
        <div class="p-grid">
          <!-- Entity Type Dropdown -->
          <div class="p-col-6 p-mb-3">
            <span class="p-float-label">
              <p-dropdown [style]="{'width':'100%'}" [(ngModel)]="multipleEntityType" [options]="entityTypeOptions"
                optionLabel="label" optionValue="value" [autoDisplayFirst]="false" [required]="true" [showClear]="true"
                (ngModelChange)="onEntityValueChanged($event, true)"></p-dropdown>
              <label>Entity Type <strong style="color: crimson">*</strong></label>
            </span>
          </div>

          <!-- Bundle Type Dropdown -->
          <div class="p-col-6 p-mb-3">
            <span class="p-float-label">
              <p-dropdown [style]="{'width':'100%'}" [(ngModel)]="multipleAssetType" [options]="imageryOptions"
                optionLabel="label" optionValue="value" [autoDisplayFirst]="false" [required]="true" [filter]="true"
                (onChange)="changePathPrefix($event)"></p-dropdown>
              <label>Bundle Type <strong style="color: crimson">*</strong></label>
            </span>
          </div>

          <!-- CSV Info and Upload -->
          <div class="p-col-12 p-mb-3">
            <hr>
            <div class="p-grid">
              <div class="p-col-5 p-d-flex p-ai-center p-jc-center">
                <input type="file" accept=".csv" (change)="onCsvFileChange($event)" pInputText />
              </div>
              <div class="p-col-7 p-d-flex p-ai-center p-jc-center">
                <p-tag severity="info" class="p-m-1" value="Upload a CSV file with name and Path"></p-tag>
                <button pButton type="button" icon="pi pi-download" label="Download Example CSV" 
                  class="p-button-secondary p-button-sm p-ml-2" (click)="downloadExampleCsv()"></button>
              </div>
            </div>
            <hr>
            <small>You can also add assets manually by clicking on the "Add Another Asset" button below.</small>
          </div>

          <!-- Dynamic input fields -->
          <div class="p-col-12">
            <div *ngFor="let asset of multipleAssets; let i = index" class="p-grid p-mb-4">
              <div class="p-col-5">
                <span class="p-float-label">
                  <input [(ngModel)]="asset.name" pInputText class="p-inputtext-sm" style="width: 100%;" />
                  <label>Name</label>
                </span>
              </div>
              <div class="p-col-5">
                <span class="p-float-label">
                  <input [(ngModel)]="asset.path" pInputText class="p-inputtext-sm" style="width: 100%;" />
                  <label>Path</label>
                </span>
              </div>
              <div class="p-col-2">
                <button pButton type="button" icon="pi pi-trash" class="p-button-danger p-button-sm"
                  (click)="removeAssetRow(i)" [disabled]="multipleAssets.length === 1"></button>
              </div>
            </div>
          </div>

          <!-- Add new row button -->
          <div class="p-col-12 p-m-0">
            <button pButton type="button" icon="pi pi-plus" label="Asset Row" class="p-button-primary"
              (click)="addNewAssetRow()"></button>
          </div>

          <!-- Build buttons for multiple assets -->
          <div class="p-col-12">
            <div class="p-grid p-mx-3">
              <div class="p-col-12">
                <div class="p-my-3 p-d-flex p-jc-center p-ai-center p-flex-wrap">
                  <build-asset [skipMiscValidation]="validateDupPath" [entity]="getMultipleAssetsEntity()"
                    [createMiscRecord]="true" [path]="''" [btnDisabled]="!isValidMultipleAssets()" [type]="type"
                    (triggerCompleteEvent)="formSubmittedTrigger($event)" label="Submit and Build All"
                    [buildType]="buildType"></build-asset>
                  <build-asset [skipMiscValidation]="validateDupPath" class="p-mx-3"
                    [entity]="getMultipleAssetsEntity()" [createMiscRecord]="true" [path]="''"
                    [btnDisabled]="!isValidMultipleAssets()" [type]="type"
                    (triggerCompleteEvent)="formSubmittedTrigger($event)"
                    label="Submit and Build All with High Priority" [buildType]="buildType"
                    [isHighPriority]="true"></build-asset>
                  <build-asset [skipMiscValidation]="validateDupPath" [entity]="getMultipleAssetsEntity()"
                    [createMiscRecord]="true" [skipBuild]="true" [path]="''" [btnDisabled]="!isValidMultipleAssets()"
                    [type]="type" (triggerCompleteEvent)="formSubmittedTrigger($event)"
                    label="Submit All and Skip Build" [buildType]="buildType"></build-asset>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="selectedCreationMode === 'single'" class="p-col-12">
        <div class="p-grid">
          <div class="p-col-12 p-inputgroup">
            <span ngClass="p-float-label">
              <input [(ngModel)]="entity.name" pInputText class="field-item" />
              <label for="entity.name">Name <strong style="color: crimson">*</strong></label>
            </span>
          </div>
          <div class="p-col-6 p-my-2">
            <span ngClass="p-float-label">
              <p-dropdown [style]="{'width':'100%'}" [(ngModel)]="entity.entityType" [ngModelOptions]="{standalone: true}"
                [options]="entityTypeOptions" optionLabel="label" optionValue="value" [autoDisplayFirst]="false"
                [required]="true" [showClear]="true" (ngModelChange)="onEntityValueChanged($event)"></p-dropdown>
              <label for="entityTypeSelection">Entity Type <strong style="color: crimson">*</strong></label>
            </span>
          </div>
          <div class="p-col-6 p-my-2">
            <span ngClass="p-float-label">
              <p-dropdown [style]="{'width':'100%'}" [(ngModel)]="entity.assetType" [options]="imageryOptions"
                optionLabel="label" optionValue="value" [autoDisplayFirst]="false" [required]="true" [filter]="true"
                (onChange)="changePathPrefix($event)"></p-dropdown>
              <label for="dropdown">Bundle Type <strong style="color: crimson">*</strong></label>
            </span>
          </div>
          <div class="p-col-12 p-my-2" *ngIf="entity.assetType === assetTypes.Theme">
            <label class="theme-additive-label">Theme Additives</label>
            <p-autoComplete
              [(ngModel)]="entity.themeAdditive_ref"
              [suggestions]="themeAdditiveResults"
              (completeMethod)="searchThemeAdditives($event)"
              [multiple]="true"
              [style]="{'width':'100%'}"
              [minLength]="1"
              [showEmptyMessage]="true"
              emptyMessage="No Theme Additives found"
              appendTo="body"
              styleClass="theme-additive-autocomplete">
              <ng-template let-item pTemplate="selectedItem">
                <span>{{ item?.name }}</span>
              </ng-template>
              <ng-template let-item pTemplate="item">
                <span>{{ item?.name }} ({{ item?.id }})</span>
              </ng-template>
            </p-autoComplete>
          </div>
        </div>
        <div class="p-col-12 p-mb-3 align-right">
          <p-toggleButton onLabel="Localized" offLabel="Not Localized" [onIcon]="'fa-solid fa-language'"
            offIcon="fa-solid fa-xmark" [(ngModel)]="entity.localized"
            pTooltip="Check if image has Localized text versions (es, fr, de)" tooltipPosition="top">
          </p-toggleButton>
        </div>
        <div class="p-col-12">
          <div class="p-grid p-mx-3">
            <div class="p-col-8 p-p-0">
              <div class="p-mb-1">
                <p-tag icon="pi pi-info-circle" severity="info"
                  value="Add '/' at the end of the path to look for files inside a folder or directory."></p-tag>
              </div>
            </div>
            <div class="p-col-4 p-p-0 align-right">
              <div class="">
                <p-checkbox inputId="check" [(ngModel)]="validateDupPath" [binary]="true" inputId="binary"></p-checkbox>
                <label for="check" style="font-size: small; margin-left: 10px;"> Allow Duplicate Path?</label>
              </div>
            </div>
            <div class="p-col-12">
              <div class="">
                <div class="p-inputgroup" style="width: 100%;">
                  <plastic-files-autocomplete *ngIf="!isLoading" [(path)]="path" (onChange)="buildPath($event)"
                    style="width: 100%;"></plastic-files-autocomplete>
                </div>
              </div>
            </div>
            <div class="p-col-12">
              <div class="p-grid p-mx-3">
                <div class="p-col-12">
                  <div class="p-mt-3 p-d-flex p-jc-center p-ai-center p-flex-wrap">
                    <build-asset [skipMiscValidation]="validateDupPath" [entity]="entity" [createMiscRecord]="true"
                      [path]="entity.path"
                      [btnDisabled]="!isValidPath || entity.entityType === undefined || entity.entityType === null || entity.assetType === undefined || entity.assetType === null"
                      [type]="type" (triggerCompleteEvent)="formSubmittedTrigger($event)" label="Submit and Build"
                      [buildType]="buildType"></build-asset>
                    <build-asset [skipMiscValidation]="validateDupPath" class="p-mx-3" [entity]="entity"
                      [createMiscRecord]="true" [path]="entity.path"
                      [btnDisabled]="!isValidPath || entity.entityType === undefined || entity.entityType === null || entity.assetType === undefined || entity.assetType === null"
                      [type]="type" (triggerCompleteEvent)="formSubmittedTrigger($event)"
                      label="Submit and Build with High Priority" [buildType]="buildType"
                      [isHighPriority]="true"></build-asset>
                    <build-asset [skipMiscValidation]="validateDupPath" [entity]="entity" [createMiscRecord]="true"
                      [skipBuild]="true" [path]="entity.path"
                      [btnDisabled]="!isValidPath || entity.entityType === undefined || entity.entityType === null || entity.assetType === undefined || entity.assetType === null"
                      [type]="type" (triggerCompleteEvent)="formSubmittedTrigger($event)" label="Submit and Skip Build"
                      [buildType]="buildType"></build-asset>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</p-dialog>